<template>
  <div>
    <section class="section-offerlist">
      <div class="container container-loader" v-if="shownone">
        <div class="d-flex flex-row justify-content-center">
          <!--  <img src="/images/loader.gif" alt="" /> -->
          <p v-if="$route.name !== 'offers-favories'" class="title-list mt-3">
            {{
              $t("translation.Aucune offre ne correspond à votre recherche")
            }}.<br />
            <span class="search-list" v-html="searchSubTitle"></span>
          </p>
          <p v-if="$route.name === 'offers-favories'" class="title-list mt-3">
            {{ $t("translation.Aucune offre dans vos favoris") }}
          </p>
        </div>
      </div>
      <div class="container" v-else>
        <div class="row logements">
          <div class="col-md-12 mb-3 text-center" v-if="offers.length">
            <div
              v-if="$route.name !== 'offers-favories'"
              class="title-list mt-3 color-red bis"
              v-html="searchSubTitle"
            ></div>

            <p v-else class="title-list mt-3 color-red bis">
              {{ $t("translation.Mes_favoris") }}
            </p>
          </div>
        </div>
        <div class="row pb-5">
          <div class="col-md-10">
            <div v-html="$t('translation.BiensRemarquables')"></div>
          </div>
          <div class="col-md-2 text-right">
            <button class="btn btn-primary" @click="gotoContact">
              {{ $t("translation.Contactez_Nous") }}
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div
                class="col-md-6 d-flex flex-column mb-4 "
                v-for="offer in offers"
                :key="offer.of_id"
              >
                <div
                  class="container-oneoffer d-flex flex-column align-items-start"
                >
                  <div
                    class="offer-images mb-2 w-100"
                    v-if="offer.images.length"
                  >
                    <div class="offer-exclusivite" v-if="offer.of_exclusivite">
                      {{ excluTxt(offer) }}
                    </div>
                    <immo-carousel-offer
                      :images="offer.images"
                      :of_id="offer.of_id"
                      :canEnlarge="false"
                      :showFavorite="true"
                      imageSize="small"
                      @clickimg="goOffer(offer)"
                    />
                  </div>
                  <div class="offer-info mb-auto" @click="goOffer(offer)">
                    <div class="offer-topprice bis">
                      <span v-if="offer.of_sell">{{
                        $t("translation.Vente")
                      }}</span>
                      <span v-if="offer.of_sell && offer.of_rent"> / </span>
                      <span v-if="offer.of_rent">{{
                        $t("translation.Location")
                      }}</span>
                      <span
                        v-if="
                          offer.bu_id &&
                            offer.bu_id.bu_city.toLowerCase() !== 'monaco'
                        "
                      >
                        | {{ offer.bu_id.bu_city }}</span
                      >
                      <span
                        v-if="
                          offer.bu_id &&
                            offer.bu_id.bu_city.toLowerCase() === 'monaco' &&
                            offer.bu_id.bu_district
                        "
                      >
                        | {{ offer.bu_id.bu_district }}</span
                      >
                      <span v-if="offer.bu_id.cu_id">
                        | {{ offer.bu_id.cu_id.cu_name_fr }}</span
                      >
                    </div>

                    <div
                      class="offer-title bis pointer withcursor"
                      style="line-height:2rem;"
                    >
                      {{ offer["of_name_" + $i18n.locale.toLowerCase()] }}
                    </div>
                    <div class="title-hr"></div>
                    <p
                      class="offer-resume"
                      v-html="offer['of_text_' + $i18n.locale.toLowerCase()]"
                    ></p>
                    <div class="">
                      <a
                        href="javascript:void(0)"
                        @click="goOffer(offer)"
                        style="color:#f14065"
                        >{{ $t("translation.moreinformation") }}</a
                      >
                    </div>
                  </div>
                  <div class="offer-block2 w-100" @click="goOffer(offer)">
                    <div>
                      <div class="offer-price color-red ">
                        <span v-if="offer.of_sell">{{
                          offer.of_price_sell
                        }}</span>
                        <span v-if="offer.of_sell && offer.of_rent"> / </span>
                        <span v-if="offer.of_rent">{{
                          offer.of_price_rent
                        }}</span>
                      </div>
                      <table style="width:100%" class="offer-detail color-gray">
                        <tr>
                          <td>
                            <div class="d-flex flex-row align-items-center">
                              <icon
                                width="20"
                                height="20"
                                class="mr-2"
                                name="bed"
                              ></icon>
                              <div class="service">
                                {{ $t("translation.Chambres") }} :
                              </div>
                            </div>
                          </td>
                          <td>
                            <div>{{ offer.of_nbrooms }}</div>
                          </td>
                        </tr>
                        <tr v-if="offer.of_surface">
                          <td>
                            <div class="d-flex flex-row align-items-center">
                              <icon
                                width="20"
                                height="20"
                                class="mr-2"
                                name="vector-square"
                              ></icon>
                              <div class="service">
                                {{ $t("translation.Surface_totale") }} :
                              </div>
                            </div>
                          </td>
                          <td>
                            <div>{{ offer.of_surface }} m<sup>2</sup></div>
                          </td>
                        </tr>
                        <tr v-else-if="offer.of_surface_livable">
                          <td>
                            <div class="d-flex flex-row align-items-center">
                              <icon
                                width="20"
                                height="20"
                                class="mr-2"
                                name="vector-square"
                              ></icon>
                              <div class="service">
                                {{ $t("translation.Surface_habitable") }} :
                              </div>
                            </div>
                          </td>
                          <td>
                            <div>
                              {{ offer.of_surface_livable }} m<sup>2</sup>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div class="d-flex flex-row align-items-center">
                              <icon
                                width="20"
                                height="20"
                                class="mr-2"
                                name="building"
                              ></icon>
                              <div class="service">
                                {{ $t("translation.Immeuble") }} :
                              </div>
                            </div>
                          </td>
                          <td>
                            <div>
                              {{ offer.bu_id ? offer.bu_id.bu_name : "" }}
                            </div>
                          </td>
                        </tr>
                      </table>

                      <div
                        class="d-flex mt-3 pb-3 justify-content-center flex-wrap"
                      >
                        <div
                          class="mr-2"
                          v-for="service in items_of_services_filtered(offer)"
                          :key="'of_service_' + service.value"
                        >
                          <img
                            class="service-icon"
                            :src="'/images/icones-services/' + service.icon"
                            :alt="
                              service['label_' + $i18n.locale.toLowerCase()]
                            "
                          />
                        </div>
                      </div>

                      <!-- <div class="offer-detail row color-gray">
                        <div class="col-6">
                          <div class="d-flex flex-row align-items-center">
                            <icon
                              width="20"
                              height="20"
                              class="mr-2"
                              name="bed"
                            ></icon>
                            <div class="service">
                              {{ $t("translation.Chambres") }} :
                            </div>
                          </div>
                        </div>
                        <div class="col-6 d-flex flex-row">
                          <div>{{ offer.of_nbrooms }}</div>
                        </div>
                      </div>

                      <div class=" offer-detail row color-gray">
                        <div class="col-6">
                          <div class="d-flex flex-row align-items-center">
                            <icon
                              width="20"
                              height="20"
                              class="mr-2"
                              name="vector-square"
                            ></icon>
                            <div class="service">
                              {{ $t("translation.Surface_totale") }} :
                            </div>
                          </div>
                        </div>
                        <div class="col-6 d-flex flex-row">
                          <div>{{ offer.of_surface }} m<sup>2</sup></div>
                        </div>
                      </div>
                      <div class="row offer-detail color-gray">
                        <div class="col-6">
                          <div class="d-flex flex-row align-items-center">
                            <icon
                              width="20"
                              height="20"
                              class="mr-2"
                              name="building"
                            ></icon>
                            <div class="service">
                              {{ $t("translation.Immeuble") }} :
                            </div>
                          </div>
                        </div>
                        <div class="col-6 d-flex flex-row">
                          <div>
                            {{ offer.bu_id ? offer.bu_id.bu_name : "" }}
                          </div>
                        </div>
                      </div> -->
                      <div
                        class="row offer-detail color-gray"
                        v-if="offer.of_district"
                      >
                        <div class="col-md-6 col-sm-6">
                          <div class="d-flex flex-row align-items-center">
                            <icon
                              width="22"
                              height="20"
                              class="mr-2"
                              name="map-pin"
                            ></icon>
                            <div class="service">
                              {{ $t("translation.Quartier") }} :
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 col-sm-6 d-flex flex-row">
                          <div>{{ offer.of_district }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="row" v-if="offers_total > 0">
          <div class="col-md-12">
            <nav aria-label="Page navigation example">
              <ul class="pagination justify-content-center align-items-center">
                <li class="page-item">
                  <button
                    :disabled="this.currentPage === 1"
                    class="page-link d-flex flex-row align-items-center"
                    tabindex="-1"
                    @click="changePage('prev')"
                  >
                    <icon class="chevron" name="chevron-left"></icon>
                    <span class="sr-only">Previous</span>
                  </button>
                </li>
                <li class="page-item mx-4">{{ currentPage }}/{{ nbPage }}</li>
                <li class="page-item">
                  <button
                    @click="changePage('next')"
                    :disabled="currentPage === nbPage"
                    class="page-link d-flex flex-row align-items-center"
                  >
                    <icon class="chevron" name="chevron-right"></icon>
                    <span class="sr-only">Next</span>
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div> -->
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "immoofferlist",
  components: {},
  data() {
    return {
      items_of_services: [],
      offers: [],
      offers_total: 0,
      nbOfferPage: 1000,
      nbPage: 0,
      currentPage: 1,
      shownone: false,
      //recherches//
      timeoutSearch: null,
      type: 0,
      // filter: this.$_.cloneDeep(this.$store.state.offersfilters),
      // filter_type: false,
      // filter_surface: false,
      // filter_budget: false,
      // filter_date: false,
      //schoolSelectedSlug: "",
      traductions: {
        fr: {},
        en: {},
        ru: {},
        it: {},
        sp: {}
      }
    };
  },
  computed: {
    searchTitle() {
      let txt = "";
      // let filter = this.$store.state.offersfilters;
      // if (
      //   !filter.rent &&
      //   !filter.sale &&
      //   !filter.france &&
      //   !filter.monaco &&
      //   !filter.budgetmax
      // ) {
      //   txt += "<p class='mb-0'>" + this.offers_total + " offre";
      //   if (this.offers_total > 1) txt += "s";
      // } else {
      //   txt += "<p class='mb-0'>" + this.offers_total;
      //   if ((filter.rent && filter.sale) || (!filter.rent && !filter.sale)) {
      //     txt += " " + this.$t("translation.Location");
      //     if (this.offers_total > 1) txt += "s ";
      //     else txt += " ";
      //     txt += " / " + this.$t("translation.Vente");
      //     if (this.offers_total > 1) txt += "s ";
      //     else txt += " ";
      //   }
      //   if (filter.sale && !filter.rent) {
      //     txt += " " + this.$t("translation.Vente");
      //     if (this.offers_total > 1) txt += "s ";
      //     else txt += " ";
      //   }
      //   if (!filter.sale && filter.rent) {
      //     txt += " " + this.$t("translation.Location");
      //     if (this.offers_total > 1) txt += "s ";
      //     else txt += " ";
      //   }
      //   if (filter.monaco || filter.france) txt += " - ";
      //   if (filter.monaco && !filter.france) txt += "Monaco";
      //   if (filter.france && !filter.monaco)
      //     txt += this.$t("translation.Cote_dazur");
      //   if (filter.france && filter.monaco)
      //     txt += "Monaco - " + this.$t("translation.Cote_dazur");
      //   txt += "</p>";
      // }
      // txt += "<p class='mb-0'>" + this.offers_total + " ";
      txt += this.$t("translation.Offre");
      if (this.offers_total > 1) txt += "s";
      return txt;
    },
    searchSubTitle() {
      return this.$options.filters.formatsearch(this.$t.bind(this));
    }
    // filter_type_text() {
    //   if (!this.filter.types.length) return "Type de logement";
    //   let txt = this.$_.result(
    //     this.$_.find(this.items_type_logement, { value: this.type }),
    //     "text",
    //     "Type de logement"
    //   );
    //   if (this.type === "1") {
    //     if (
    //       this.filter.room_1 ||
    //       this.filter.room_2 ||
    //       this.filter.room_3 ||
    //       this.filter.room_4
    //     )
    //       txt += " : ";
    //     if (this.filter.room_1) txt += "Studio, ";
    //     if (this.filter.room_2) txt += "T2, ";
    //     if (this.filter.room_3) txt += "T3, ";
    //     if (this.filter.room_4) txt += "T4";
    //   }
    //   return txt;
    // },
    // filter_budget_text() {
    //   // console.log("this.filter", this.filter);
    //   if (!this.filter.budgetmin && !this.filter.budgetmax) return "Budget";
    //   if (this.filter.budgetmin && this.filter.budgetmax)
    //     return (
    //       "De " +
    //       this.$options.filters.formatPrice(this.filter.budgetmin) +
    //       " à " +
    //       this.$options.filters.formatPrice(this.filter.budgetmax)
    //     );
    //   else if (this.filter.budgetmin) {
    //     return (
    //       "A partir de " +
    //       this.$options.filters.formatPrice(this.filter.budgetmin)
    //     );
    //   } else {
    //     return (
    //       "Jusqu'à " + this.$options.filters.formatPrice(this.filter.budgetmax)
    //     );
    //   }
    // },
    // filter_surface_text() {
    //   if (!this.filter.surfacemin && !this.filter.surfacemax) return "Surface";
    //   if (this.filter.surfacemin && this.filter.surfacemax)
    //     return (
    //       "De " +
    //       this.$options.filters.formatSurface(this.filter.surfacemin) +
    //       " à " +
    //       this.$options.filters.formatSurface(this.filter.surfacemax)
    //     );
    //   else if (this.filter.surfacemin) {
    //     return (
    //       "A partir de " +
    //       this.$options.filters.formatSurface(this.filter.surfacemin)
    //     );
    //   } else {
    //     return (
    //       "Jusqu'à " +
    //       this.$options.filters.formatSurface(this.filter.surfacemax)
    //     );
    //   }
    // },
    // filter_date_text() {
    //   if (!this.filter.datestart || !this.filter.dateend) return "Date";
    //   return (
    //     "Du " +
    //     this.$options.filters.formatDate(this.filter.datestart) +
    //     " au " +
    //     this.$options.filters.formatDate(this.filter.dateend)
    //   );
    // },
    // items_type_logement() {
    //   if (this.$store.state.items.items_of_type) {
    //     // @Marina : il ne faut  pas modifier des trucs dans le storeX... ici en l'occurence cela faisait un bug sans le filter (le filter permet de renvoyer une COPIE du array)
    //     let items = this.$store.state.items.items_of_type.filter(() => true);
    //     items.unshift({ text: "Tous les types", value: 0 });
    //     return items;
    //   } else {
    //     return [];
    //   }
    // },
    // items_school() {
    //   if (this.$store.state.items.schools) {
    //     // @Marina : il ne faut  pas modifier des trucs dans le storeX... ici en l'occurence cela faisait un bug sans le filter (le filter permet de renvoyer une COPIE du array)
    //     let items = this.$store.state.items.schools.filter(() => true);
    //     items.unshift({ text: "Distance jusqu'à", value: 0 });
    //     return items;
    //   } else {
    //     return [];
    //   }
    // }
  },
  watch: {
    // filter() {
    //   this.loadOffers();
    // },
    /*     schoolSelectedSlug(v) {
      this.loadOffers();
    }, */
    $route(to, from) {
      // console.log("to,from", to, from);
      this.createRoute();
      this.loadOffers();
      // this.filter.favories = [];
      // if (this.$route.name === "offers-favories") {
      //   this.offers = [];
      //   this.cancelAllFilter();
      //   this.filter.favories = this.$store.state.favories;
      //   if (this.filter.favories.length) {
      //     this.$store.commit("set_offersfilters", this.filter);
      //     this.loadOffers();
      //   }
      // }
      // if (this.$route.name === "offers-sales") {
      //   this.cancelAllFilter();
      //   this.filter.sale = true;
      //   this.$store.commit("set_offersfilters", this.filter);
      // }
      // if (this.$route.name === "offers-rentals") {
      //   this.cancelAllFilter();
      //   this.filter.rent = true;
      //   this.$store.commit("set_offersfilters", this.filter);
      // }
      // this.currentPage = this.$route.params.page
      //   ? this.$route.params.page * 1
      //   : 1;
      // if (
      //   (this.$route.name === "offers-favories" &&
      //     this.filter.favories.length) ||
      //   this.$route.name !== "offers-favories"
      // ) {
      //   this.loadOffers();
      // }
    }
  },
  async mounted() {
    // this.filter.favories = [];
    // if (this.$route.name === "offers-favories") {
    //   this.cancelAllFilter();
    //   this.filter.favories = this.$store.state.favories;
    //   if (this.filter.favories.length) {
    //     this.$store.commit("set_offersfilters", this.filter);
    //     this.loadOffers();
    //   }
    // }
    // if (this.$route.name === "offers-sales") {
    //   this.cancelAllFilter();
    //   this.filter.sale = true;
    //   this.$store.commit("set_offersfilters", this.filter);
    // }
    // if (this.$route.name === "offers-rentals") {
    //   this.cancelAllFilter();
    //   this.filter.rent = true;
    //   this.$store.commit("set_offersfilters", this.filter);
    // }
    window.addEventListener("click", this.onWindowClick);
    // this.currentPage = this.$route.params.page
    //   ? this.$route.params.page * 1
    //   : 1;
    /*     if (this.$route.params.schoolslug)
      this.schoolSelectedSlug = this.$route.params.schoolslug; */
    // if (
    //   (this.$route.name === "offers-favories" && this.filter.favories.length) ||
    //   this.$route.name !== "offers-favories"
    // ) {
    //   this.loadOffers();
    // }
    this.createRoute();
    this.loadOffers();
  },
  destroyed() {
    window.removeEventListener("click", this.onWindowClick);
  },
  methods: {
    gotoContact() {
      this.$router.push("/contact");
    },
    items_of_services_filtered(offer) {
      // console.log(
      //   "this.items_of_services",
      //   this.items_of_services,
      //   offer.of_services
      // );
      return this.items_of_services.filter(item => {
        if (window.BigInt)
          return window.BigInt(offer.of_services) & window.BigInt(item.value);
        return offer.of_services & item.value;
      });
    },
    excluTxt(offer) {
      let txt = this.$options.filters.formatFromArray(
        offer.of_exclusivite,
        this.$store.state.items_of_exclusivite
      );

      // console.log("txt", txt);
      return this.$t("translation." + txt);
    },
    // cancelAllFilter() {
    //   this.filter.types = [];
    //   this.filter.typesobj = {};
    //   this.type = 0;
    //   this.filter.room_1 = false;
    //   this.filter.room_2 = false;
    //   this.filter.room_3 = false;
    //   this.filter.room_4 = false;
    //   this.filter.room_5 = false;
    //   this.filter.monaco = false;
    //   this.filter.france = false;
    //   this.filter.rent = false;
    //   this.filter.sale = false;
    //   this.filter.budgetmin = "0";
    //   this.filter.budgetmax = "400000000";
    //   this.filter.favories = [];
    //   this.sale = 0;
    // },
    createRoute(newPage = 0) {
      // console.log("createRoute");
      if (this.$route.path === "/offers/favories") {
        this.$store.dispatch("cancelAllFilter");
        let filterClone = this.$_.cloneDeep(this.$store.state.offersfilters);
        filterClone.favories = this.$store.state.favories;
        this.$store.commit("set_offersfilters", filterClone);
        return;
      } else {
        // on écrit dans le store les filtres si on arrive sur une route avec des arguments (et non pas /offers simplement)
        if (this.$route.path !== "/offers" || newPage > 0) {
          // console.log("this.$route.params.salerent", this.$route.params.salerent);
          this.$store.dispatch("cancelAllFilter");
          let filterClone = this.$_.cloneDeep(this.$store.state.offersfilters);

          if (newPage > 0) filterClone.page = newPage;
          else if (this.$route.params.page)
            filterClone.page = this.$route.params.page * 1;

          if (this.$route.params.where == "monaco") filterClone.monaco = true;
          if (this.$route.params.where == "france") filterClone.france = true;
          if (this.$route.params.where == "international")
            filterClone.international = true;
          if (
            this.$route.params.where != "international" &&
            this.$route.params.where != "france" &&
            this.$route.params.where != "monaco"
          )
            filterClone.district = this.$route.params.where;
          else filterClone.district = "";
          if (this.$route.params.salerent == "sales") filterClone.sale = true;
          if (this.$route.params.salerent == "rents") filterClone.rent = true;
          if (this.$route.params.pieces !== "pieces-all") {
            let piecesOk = this.$route.params.pieces.substring(7).split("-");
            if (piecesOk.indexOf("1") >= 0) filterClone.room_1 = true;
            if (piecesOk.indexOf("2") >= 0) filterClone.room_2 = true;
            if (piecesOk.indexOf("3") >= 0) filterClone.room_3 = true;
            if (piecesOk.indexOf("4") >= 0) filterClone.room_4 = true;
            if (piecesOk.indexOf("5") >= 0) filterClone.room_5 = true;
          }
          if (this.$route.params.budget !== "budget-all") {
            let budgetOk = this.$route.params.budget.substring(7).split("-");
            if (budgetOk.length >= 2) {
              filterClone.budgetmin = budgetOk[0] * 1;
              filterClone.budgetmax = budgetOk[1] * 1;
            }
          }
          if (this.$route.params.types !== "types-all") {
            filterClone.types = [];
            filterClone.typesobj = {};
            let typesOk = this.$route.params.types.substring(6).split("-");
            for (let iType = 0; iType < typesOk.length; iType++) {
              const type = typesOk[iType];
              let v = this.$_.find(this.$store.state.items.items_of_type, {
                value: type
              });
              if (v) {
                filterClone.types.push(v.value);
                filterClone.typesobj[v.text] = v.value;
              }
            }
          }
          this.$store.commit("set_offersfilters", filterClone);
        }

        // on lit les filtres que l'on vient peut-être d'écrire
        // this.$router.push("/offers/:where/:salerent/:types/:pieces/:budget/:page");
        let filter = this.$store.state.offersfilters;
        let where = "monaco_and_france",
          salerent = "rents_and_sales",
          types = "types-",
          pieces = "pieces-",
          budget = "budget-";

        if (filter.page) {
          this.currentPage = filter.page;
        }

        if (filter.monaco && !filter.france) where = "monaco";
        if (filter.france && !filter.monaco) where = "france";
        if (filter.district) where = filter.district;
        if (this.$route.params.where === "international")
          where = "international";

        if (filter.sale && !filter.rent) salerent = "sales";
        if (filter.rent && !filter.sale) salerent = "rents";

        let piecesOk = [];
        if (filter.room_1) piecesOk.push(1);
        if (filter.room_2) piecesOk.push(2);
        if (filter.room_3) piecesOk.push(3);
        if (filter.room_4) piecesOk.push(4);
        if (filter.room_5) piecesOk.push(5);
        if (
          (filter.room_1 &&
            filter.room_2 &&
            filter.room_3 &&
            filter.room_4 &&
            filter.room_5) ||
          (!filter.room_1 &&
            !filter.room_2 &&
            !filter.room_3 &&
            !filter.room_4 &&
            !filter.room_5)
        )
          piecesOk = [];
        if (piecesOk.length) pieces += piecesOk.join("-");
        else pieces += "all";

        filter.types = [];
        this.$_.each(filter.typesobj, (val, key) => {
          if (val) {
            let v = this.$_.find(this.$store.state.items.items_of_type, {
              text: key
            });
            if (v) filter.types.push(v.value);
          }
        });
        if (filter.types.length === 0) {
          types += "all";
        } else {
          types += filter.types.join("-");
        }

        if (filter.budgetmin == "0" && filter.budgetmax == "400000000") {
          budget += "all";
        } else {
          budget += filter.budgetmin + "-" + filter.budgetmax;
        }

        this.$router.push(
          `/offers/${where}/${salerent}/${types}/${pieces}/${budget}/${this.currentPage}`
        );
      }
    },
    async loadOffers() {
      // console.log("this.filter", this.filter);
      let filter = this.$_.cloneDeep(this.$store.state.offersfilters);
      console.log("filter", filter);
      this.shownone = false;
      filter.types = [];
      this.$_.each(filter.typesobj, (val, key) => {
        if (val) {
          let v = this.$_.find(this.$store.state.items.items_of_type, {
            text: key
          });
          if (v) filter.types.push(v.value);
        }
      });
      let params = filter;
      delete params.page;

      if (this.$route.params.where === "international")
        params.international = true;
      // console.log("this.currentPage", this.currentPage, params);

      params.skip = (this.currentPage - 1) * this.nbOfferPage;
      params.limit = this.nbOfferPage;
      params.lang = this.$store.state.lang;
      let response = await this.$axios.get(
        this.$config.server_url + "/web/1.0/offers",
        { params }
      );
      if (!response || !response.data) return;
      this.offers = response.data.data;
      this.offers_total = response.data.meta.total * 1;
      this.$store.commit("set_offers", {
        offers: response.data.meta.rows_all
      });
      this.nbPage = Math.ceil(this.offers_total / this.nbOfferPage);
      if (
        this.offers_total === 0 ||
        (!this.$store.state.favories.length &&
          this.$route.path === "/offers/favories")
      )
        this.shownone = true;
      this.items_of_services = response.data.items_services;
      // console.log(
      //   "this.offers_total, this.shownone",
      //   this.offers_total,
      //   this.shownone
      // );
    },
    /*     openFilter(key) {
      let open = this[key];
      this.filter_type = false;
      this.filter_surface = false;
      this.filter_budget = false;
      this.filter_date = false;
      if (!open) this[key] = true;
    },
    onclickDropdown(evt) {
      evt.stopPropagation();
    },
    onWindowClick() {
      this.filter_type = false;
      this.filter_surface = false;
      this.filter_budget = false;
      this.filter_date = false;
    }, */
    clearTimeoutSearch() {
      //clearTimeout(this.timeoutSearch);
    },
    // maybeValidFilter(filter) {
    //   /*       this.clearTimeoutSearch();
    //   this.timeoutSearch = setTimeout(() => {
    //    this.loadOffers()
    //   }, 300); */
    // },
    // validFilter(filter, closeFilter = true) {
    //   if (closeFilter) {
    //     let filterData = "filter_" + filter;
    //     this[filterData] = false;
    //   }
    // },
    // cancelFilter(filter) {
    //   switch (filter) {
    //     case "type":
    //       this.filter.room_1 = false;
    //       this.filter.room_2 = false;
    //       this.filter.room_3 = false;
    //       this.filter.room_4 = false;
    //       this.filter.types = [];
    //       this.type = 0;
    //       break;
    //     case "budget":
    //       this.filter.budgetmin = "";
    //       this.filter.budgetmax = "";
    //       break;
    //     case "surface":
    //       this.filter.surfacemin = "";
    //       this.filter.surfacemax = "";
    //       break;
    //     case "date":
    //       this.filter.datestart = "";
    //       this.filter.dateend = "";
    //       break;
    //     default:
    //       break;
    //   }
    //   this["filter_" + filter] = false;
    //   this.loadOffers();
    // },
    goOffer(offer) {
      this.$router.push("/offers/details/" + offer.of_slug_fr);
    },
    changePage(sens) {
      // let route = "";
      let page = this.currentPage;
      if (sens === "prev") page -= 1;
      else page += 1;
      this.createRoute(page);
      this.loadOffers();
      // this.$router.push(route);
    }
  }
};
</script>
<style scoped lang="scss">
@import "../../node_modules/bootstrap/scss/bootstrap.scss";
@import "../scss/styles.scss";
.container-loader {
  height: 60vh;
}
.section-offerlist {
  background-color: #f3f6f8;
  min-height: 500px;
}
.title-list {
  font-size: 30px;
}
.search-list {
  font-size: 16px !important;
}
.container-oneoffer {
  border: solid 1px #e2e2e2;
  background-color: #fff;
  height: 100%;
}
.offer-info {
  padding: 10px 20px 30px 20px;
  cursor: pointer;
  width: 100%;
}
.offer-block2 {
  padding: 0 20px 10px 20px;
}

.offer-topprice {
  text-transform: uppercase;
  color: #707070;
}
.title-hr {
  height: 1px;
  width: 55%;
  background-color: gray;
  margin: 10px 0 35px;
}
.offer-detail {
  font-size: 18px;
  margin-bottom: 10px;
}
.service {
  white-space: nowrap;
}
// hr {
// }
// .service {
//   font-size: 20px;
// }
// .header {
//   padding: 50px 10px;
//   background-image: url(/images/fond.png);
//   background-size: cover;
//   h1 {
//     color: #09b5d7;
//   }
//   p {
//     color: #fff;
//     font-size: 25px;
//   }
// }
// @media (min-width: 578px) {
//   .header {
//     padding: 50px 50px;
//   }
// }
// @media (min-width: 630px) {
// }
// @media (min-width: 992px) {
//   .header {
//     padding: 30px 100px;
//   }
// }
// @media (min-width: 1200px) {
//   .header {
//     padding: 30px 200px;
//   }
// }
.withcursor {
  cursor: pointer;
}
// recherche
.select .input-group {
  min-width: 220px;
}
// .filter .form-group {
//   //margin-bottom: 0;
// }
.filter-selected {
  background-color: #fdd40f;
}
.btn-filter {
  margin-left: 10px;
  margin-bottom: 10px;
  position: relative;
  border: 1px solid #cccccc;
  border-radius: 10px;
  padding: 5px 10px;
  cursor: pointer;
}
.btn-filter:hover {
  background-color: #e8e8e8;
}
.dropdown-filter {
  margin-top: 5px;
  border: 1px solid #cccccc;
  border-radius: 5px;
  margin-bottom: 10px;
  background-color: #fff;
  padding: 15px;
  box-shadow: 0 2px 6px 1px rgba(0, 0, 0, 0.15);
}
@media (min-width: 576px) {
  .dropdown-filter {
    //min-width: 250px;
    position: absolute;
    z-index: 1000;
    top: 100%;
    margin-top: 5px;
    margin-bottom: 0px;
  }
  .container-filter {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
}
// les offres
.offer-title {
  font-size: 1.6rem;
  margin-top: 5px;
  color: #3c3c3c;
}

.offer-type-detail {
  padding: 2px 7px;
  border-radius: 5px;
  color: #fff;
}
.family {
  background-color: #ffc400;
}
.appart {
  background-color: #03b1ff;
}
.page-link:hover {
  background-color: #201f1f;
}
.offer-price {
  font-size: 20px;
  margin-bottom: 16px;
}
.page-link {
  background-color: #ee064b;
  border: 0;
  height: 45px;
  .chevron {
    color: #fff;
  }
  &:disabled {
    background-color: #d4d4d4;
    .chevron {
      color: black;
    }
  }
}
/* styles for '...' */
.offer-resume {
  display: -webkit-box;
  max-height: 110px;
  font-size: 1rem;
  line-height: 1.5rem;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 5px;
  /* hide text if it more than N lines  */
  // overflow: hidden;
  // /* for set '...' in absolute position */
  // position: relative;
  // /* use this value to count block height */
  // /* max-height = line-height (1.2) * lines max number (3) */
  // max-height: 5rem;
  // /* fix problem when last visible word doesn't adjoin right side  */
  // text-align: justify;
  /* place for '...' */
  // margin-right: -1em;
  // padding-right: 1em;
}
/* create the ... */
// .offer-resume:before {
//   /* points in the end */
//   content: "...";
//   /* absolute position */
//   position: absolute;
//   /* set position to right bottom corner of block */
//   right: 15px;
//   bottom: -4px;
// }
// /* hide ... if we have text, which is less than or equal to max lines */
// .offer-resume:after {
//   /* points in the end */
//   //content: "";
//   /* absolute position */
//   position: absolute;
//   /* set position to right bottom corner of text */
//   right: 0;
//   /* set width and height */
//   width: 1em;
//   height: 1em;
//   margin-top: 0.2em;
//   /* bg color = bg color under block */
//   background: white;
// }
.offer-exclusivite {
  text-transform: uppercase;
  font-weight: bold;
  position: absolute;
  z-index: 10;
  left: 40px;
  top: 20px;
  background-color: #d71e29;
  color: white;
  padding: 1px 5px;
}
.service-icon {
  max-width: 25px;
  max-height: 25px;
  margin-bottom: 10px;
}
</style>
